import i18n from '../../../../i18n';

export const _foreasBasicDetails = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.suntomorgafiaForea
      ? [{
        name: 'Συντομογραφία Φορέα',
        value: '',
        refValue: 'suntomorgafiaForea',
      }] :
      []),
    ...(_mappedMetadata?.anagnoristikoForea
      ? [{
        name: 'Αναγνωριστικό Φορέα',
        value: '',
        refValue: 'anagnoristikoForea',
      }] :
      []),
    ...(_mappedMetadata?.sutomografiaForeaAgglika
      ? [{
        name: 'Συντομογραφία Φορέα στα αγγλικά',
        value: '',
        refValue: 'sutomografiaForeaAgglika',
      }] :
      []),
  ];
};


export const _foreasContactDetails = (_mappedMetadata: any) => {

  return [
    ...(_mappedMetadata?.foreasPhone
      ? [{
        name: 'Τηλέφωνο',
        value: '',
        refValue: 'foreasPhone',
      }] :
      []),
    ...(_mappedMetadata?.foreasEmail
      ? [{
        name: 'Email',
        value: '',
        refValue: 'foreasEmail',
      }] :
      []),
    ...(_mappedMetadata?.foreasWebsite
      ? [{
        name: 'Website',
        value: '',
        refValue: 'foreasWebsite',
      }] :
      []),
    ...(_mappedMetadata?.foreasTown
      ? [{
        name: 'Πόλη',
        value: '',
        refValue: 'foreasTown',
      }] :
      []),
    ...(_mappedMetadata?.organisationFullAddress
      ? [{
        name: 'Διεύθυνση',
        value: '',
        refValue: 'organisationFullAddress'
      }] :
      []),
    ...(_mappedMetadata?.foreasCountry
      ? [{
        name: 'Χώρα',
        value: '',
        refValue: 'foreasCountry',
      }] :
      [])

  ];
};

export const _foreasComments = (_mappedMetadata: any) => {
  return [
    ...(_mappedMetadata?.comments && i18n.language !== 'en'
      ? [{
        name: 'Παρατηρήσεις - Σχόλια',
        value: '',
        refValue: 'comments',
      }] :
      []),
    ...(_mappedMetadata?.comments_en && i18n.language === 'en'
      ? [{
        name: 'Notes - Comments',
        value: '',
        refValue: 'comments_en',
      }] :
      []),
  ];
};